<div id="beyond">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Academics</h4>
                  <div class="card-body">
                    <div class="text-center mb-5 mt-3 d-flex flex-wrap justify-content-center">
                        <a href="/assets/pdf/Academic Calander 2026-27.pdf" class="doc-btn btn-academic" download target="_blank">
                            <i class="fa fa-calendar-check-o" aria-hidden="true"></i> Academic Calendar 2026-27
                        </a>
                        <a href="/assets/pdf/List of Holidays 2026-27.pdf" class="doc-btn btn-holidays" download target="_blank">
                            <i class="fa fa-calendar-times-o" aria-hidden="true"></i> List of Holidays 2026-27
                        </a>
                    </div>
                    <p class="inner-lead">At our school, we are committed to providing a challenging and comprehensive academic programme that prepares students for success in college and beyond. Our curriculum is designed to engage students in critical thinking, problem-solving, and creativity, while also building a strong foundation in core academic subjects.</p>
                    <p class="inner-lead">We believe that a strong academic programme is a foundation for success in life, and we are committed to providing our students with the tools and resources they need to achieve their goals.
                    </p>  
                    <p class="inner-lead">Our school's football and basketball field is more than just a sports facility. It's a place where students can come together and build a sense of community through teamwork, sportsmanship, and healthy competition. Our school takes pride in providing our students with a state-of-the-art athletic facility that promotes physical fitness, self-confidence, and discipline.
                    </p>
                    <p class="inner-lead">At our school, we recognize that sports can be a powerful tool for building character and fostering personal growth. We encourage our students to participate in sports and to learn from both their successes and failures. 
                    </p>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>